import { Backdrop, Box, Button, CircularProgress, Divider, TextField } from "@mui/material";
import { QuestionResponse } from "../Models";
import { useCallback, useEffect, useState } from "react";
import { HttpService } from "../services/HttpService";
import { useHttp } from "../hooks/useHttp";

type InputChangeEventType = React.ChangeEvent<HTMLInputElement>;

interface QRFormProps {
    qr: QuestionResponse | null | undefined,
    sql: string | null,
    apiHost: string,
    modalStyle: {},
    onChangeCallback: (updatedQR: QuestionResponse) => void,
    onAddQuestionsResponsesCallback?: ((updatedQR: QuestionResponse) => void),
}

const default_style = { width: "100%" };

export default function QRForm(props: QRFormProps) {
    const { qr, sql, modalStyle, apiHost, onChangeCallback, onAddQuestionsResponsesCallback } = props;

    const [httpService, setHttpSerivce] = useState(new HttpService(apiHost));

    const [isLoading, setIsLoading] = useState(false);

    const {
        data: denormalized,
        loading: denormalizing,
        error: denormalizationError,
        sendRequest: sendDenormalizationRequest
    } = useHttp(() => httpService.post<{}>('/api/normalization/denormalizeResponse', {
        sql: sql,
        question: currentQR.question,
        response: currentQR.response,
    }));

    let currentQR: QuestionResponse = qr || new QuestionResponse(null, "", "", "", "");

    const isNew = currentQR.id === null;

    useEffect(() => {
        setHttpSerivce(new HttpService(apiHost));
    }, [setHttpSerivce, apiHost]);

    const updateQOrig = useCallback((v: InputChangeEventType) => {
        currentQR.questionOrig = v.target.value;
        onChangeCallback(currentQR);
    }, [currentQR, currentQR.questionOrig, onChangeCallback]);

    const updateQ = useCallback((v: InputChangeEventType) => {
        currentQR.question = v.target.value;
        onChangeCallback(currentQR);
    }, [currentQR, currentQR.question, onChangeCallback]);

    const updateROrig = useCallback((v: InputChangeEventType) => {
        currentQR.responseOrig = v.target.value;
        onChangeCallback(currentQR);
    }, [currentQR, currentQR.responseOrig, onChangeCallback]);

    const updateR = useCallback((v: InputChangeEventType) => {
        currentQR.response = v.target.value;
        onChangeCallback(currentQR);
    }, [currentQR, currentQR.response, onChangeCallback]);

    const onAddQuestionsResponses = useCallback(() => {
        if (!currentQR.isFilledIn()) {
            alert("All fields are required");
            return;
        }
        if (onAddQuestionsResponsesCallback) {
            onAddQuestionsResponsesCallback(currentQR);
        }
    }, [qr, currentQR, onAddQuestionsResponsesCallback]);

    const onNormalize = useCallback(() => {
        setIsLoading(true);
        fetch(`${apiHost}api/normalization/NormalizeQuestionResponse`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                sql: sql,
                question: currentQR.questionOrig,
                response: currentQR.responseOrig,
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.isError) {
                    alert(data.firstError.description);
                    return;
                }
                currentQR.question = data.value.question;
                currentQR.response = data.value.response;
                onChangeCallback(currentQR);
            })
            .catch(error => alert(error))
            .finally(() => setIsLoading(false));
    }, [httpService, currentQR, onChangeCallback, setIsLoading]);
    
    const onDenormalize = useCallback(async () => {
        debugger;
        const resp = await sendDenormalizationRequest();
    }, [apiHost, currentQR, sendDenormalizationRequest]);

    return <Box sx={modalStyle}>
        <TextField label="Question Original" multiline value={currentQR.questionOrig} style={default_style} onChange={updateQOrig} />
        <Divider orientation="vertical" flexItem > </Divider>
        <TextField label="Question" multiline value={currentQR.question} style={default_style} onChange={updateQ} />
        <Divider orientation="vertical" flexItem> </Divider>
        <TextField label="Response Original" multiline maxRows={7} value={currentQR.responseOrig} style={default_style} onChange={updateROrig} />
        <Divider orientation="vertical" flexItem> </Divider>
        <TextField label="Response" multiline value={currentQR.response} style={default_style} onChange={updateR} />
        <Divider orientation="vertical" flexItem> </Divider>
        <TextField label="Response denormalized" multiline value={denormalized} style={default_style} />

        <Divider orientation="vertical" flexItem> </Divider>
        <Button disabled={!isNew || !onAddQuestionsResponsesCallback} variant="contained" fullWidth onClick={onAddQuestionsResponses}>Add QA</Button>
        <Divider orientation="vertical" flexItem> </Divider>
        <Button
            disabled={!currentQR.questionOrig && !currentQR.responseOrig}
            variant="contained"
            fullWidth
            onClick={onNormalize}>Normalize</Button>
        <Divider orientation="vertical" flexItem> </Divider>
        <Button
            disabled={!denormalizing && !currentQR.question && !currentQR.response}
            variant="contained"
            fullWidth
            onClick={onDenormalize}>Denormalize</Button>

        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={isLoading || denormalizing}
            onClick={() => setIsLoading(!isLoading)}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </Box>
}
